import { Link } from '@react/system';
import clsxm from '@sly/frontend/common/lib/clsxm';

export default function CareScoutBanner({ className }: { className?: string }) {
  return (
    <div
      className={clsxm(
        'font-b-s bg-careScout-base p-2 text-center text-white',
        className
      )}
    >
      Great News! Seniorly has joined the CareScout family. We&apos;re excited
      to expand our services while continuing to support your family&apos;s
      journey. Read the full press release{' '}
      <Link
        className='!text-white underline'
        target='_blank'
        to='https://investor.genworth.com/news-events/press-releases/detail/1047/carescout-announces-plan-to-acquire-seniorly'
      >
        here
      </Link>
      .
    </div>
  );
}
